import React from 'react';
import { useTranslation } from '../hooks/useTranslation';

const Stats = () => {
  const { t } = useTranslation();

  return (
    <section className="py-20 px-4 lg:px-8 border-t border-b">
      <div className="container mx-auto max-w-6xl">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center justify-items-center">
          <div className="flex flex-col items-center">
            <div className="text-4xl font-bold mb-2">2.7 {t('days')}</div>
            <div className="text-sm text-muted-foreground">
              {t('statsDaysSaved')}
            </div>
          </div>
          <div className="flex flex-col items-center">
            <div className="text-4xl font-bold mb-2">98%</div>
            <div className="text-sm text-muted-foreground">
              {t('statsCustomerSatisfaction')}
            </div>
          </div>
          <div className="flex flex-col items-center">
            <div className="text-4xl font-bold mb-2">24/7</div>
            <div className="text-sm text-muted-foreground">
              {t('statsSupportAvailable')}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Stats;
